// Detail main display mode (aggregate EX display)
export type DetailMainDisplay = 'percent' | 'maxMinus';

// Re-export ScoreThreshold type from auth.ts (for API compatibility)
export type { ScoreThreshold } from './auth';
import type { ScoreThreshold } from './auth';

export const DEFAULT_SCORE_THRESHOLDS: ScoreThreshold[] = [
  { id: 'aaa', label: 'AAA 이상', minScore: 9700000, color: '#f59e0b', isDefault: true, enabled: true },
  { id: 'aaa_plus', label: 'AAA+ 이상', minScore: 9800000, color: '#eab308', isDefault: true, enabled: true },
  { id: 's', label: 'S 이상', minScore: 9900000, color: '#22c55e', isDefault: true, enabled: true },
  { id: '995', label: '995 이상', minScore: 9950000, color: '#10b981', isDefault: true, enabled: false },
  { id: '997', label: '997 이상', minScore: 9970000, color: '#14b8a6', isDefault: true, enabled: true },
];

export const MAX_SCORE_THRESHOLDS = 10;

// EX-SCORE display mode setting
export type ExScoreDisplayMode = 'percent' | 'maxMinus';

// EX-SCORE Threshold (percentage based or MAX-X based)
export type ExScoreThresholdType = 'percent' | 'maxMinus';

export interface ExScoreThreshold {
  id: string;
  label: string;
  thresholdType: ExScoreThresholdType;  // 'percent' or 'maxMinus'
  minPercent: number;  // 0-100 (used when thresholdType is 'percent')
  maxMinus?: number;   // MAX에서 몇 점 부족한지 (used when thresholdType is 'maxMinus')
  color: string;
  isDefault: boolean;
  enabled: boolean;
}

export const DEFAULT_EXSCORE_THRESHOLDS: ExScoreThreshold[] = [
  { id: 'ex_90', label: '90%+', thresholdType: 'percent', minPercent: 90, color: '#a3e635', isDefault: true, enabled: true },
  { id: 'ex_92_5', label: '92.5%+', thresholdType: 'percent', minPercent: 92.5, color: '#34d399', isDefault: true, enabled: true },
  { id: 'ex_95', label: '95%+', thresholdType: 'percent', minPercent: 95, color: '#60a5fa', isDefault: true, enabled: true },
  { id: 'ex_96', label: '96%+', thresholdType: 'percent', minPercent: 96, color: '#c084fc', isDefault: true, enabled: true },
  { id: 'ex_97', label: '97%+', thresholdType: 'percent', minPercent: 97, color: '#f472b6', isDefault: true, enabled: true },
  { id: 'ex_98', label: '98%+', thresholdType: 'percent', minPercent: 98, color: '#facc15', isDefault: true, enabled: true },
];

export const MAX_EXSCORE_THRESHOLDS = 10;

export const THRESHOLD_COLOR_OPTIONS = [
  '#ffffff', // white
  '#facc15', // yellow-400 (노랑)
  '#f59e0b', // amber-500 (주황빛 노랑)
  '#f97316', // orange-500 (주황)
  '#ef4444', // red-500 (빨강)
  '#ec4899', // pink-500 (핑크)
  '#d946ef', // fuchsia-500 (자홍)
  '#a855f7', // purple-500 (보라)
  '#6366f1', // indigo-500 (남색)
  '#3b82f6', // blue-500 (파랑)
  '#06b6d4', // cyan-500 (시안)
  '#14b8a6', // teal-500 (청록)
  '#22c55e', // green-500 (초록)
  '#84cc16', // lime-500 (라임)
];
